import { useEffect, useState } from "react";
import { AudienceSelectionProps } from "./utility/audienceSortPropTypes";
import { audienceSortStepNames } from "components/public-site/audience-sort/utility/audienceSortStepNames";
import AudienceSortModal from "./AudienceSortModal";
import ProfessionalAffirmation from "./ProfessionalAffirmation";
import getProfessionalAffirmationSplashData from "components/utility/api/GetProfessionalAffirmationSplashData";

const ProfessionalAffirmationSplashModal = () => {
	const [audienceSelectionData, setAudienceSelectionData] = useState<AudienceSelectionProps | null>(
		null
	);
	const [step, setStep] = useState(audienceSortStepNames.initialStep);
	const [isModalOpen, setIsModalOpen] = useState(true);
	const [modalJustOpened] = useState<boolean>(true);

	const currentPage = "pro-only-entry";
	const modalColorTheme = "light-theme-teal";

	useEffect(() => {
		getProfessionalAffirmationSplashData("professionalAffirmationSplashModal").then(
			(initialData) => {
				if (initialData.status === "success" && typeof initialData.data !== "string") {
					setAudienceSelectionData({
						countryKey: window["professionalAffirmationSplashModal"]?.countryKey,
						...initialData.data
					});
				}
			}
		);
	}, []);

	return (
		<AudienceSortModal
			theme={modalColorTheme}
			currentPage={currentPage}
			currentStep={step}
			setStep={setStep}
			isMobile={false}
			isModalOpen={isModalOpen}
			isWide={
				!(
					step === audienceSortStepNames.initialStep ||
					step === audienceSortStepNames.audienceTypeSelection
				)
			}
			className="audience-selector-from-link-modal"
			modalJustOpened={modalJustOpened}
			preventHandleClickOutside={true}
		>
			{audienceSelectionData && (
				<ProfessionalAffirmation
					currentPage={currentPage}
					hasCloseButton={false}
					audienceSortTheme={modalColorTheme}
					audienceSelectionData={audienceSelectionData}
					setIsModalOpen={setIsModalOpen}
					cameFromInitialStep={false}
					setStep={() => {}}
				/>
			)}
		</AudienceSortModal>
	);
};

export default ProfessionalAffirmationSplashModal;
